export const getContactDisplayName = contact => {
  if (!contact) return '';

  return contact.displayLabel || contact.display_label || contact.name || '';
};
